import { Injectable } from '@angular/core';
import { BaseService, HttpService } from '@app/core';
import { Country, CourseCustomer } from '@app/models';
import { SCData } from '@app/models/core/SCData';

import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Injectable()
export class CourseUserProfileService extends BaseService {
  constructor(private http: HttpService) {
    super();
  }

  getMeData() {
    return <Observable<SCData<CourseCustomer>>>this.http.get(`/course-user/me`);
  }

  saveMeData(data: CourseCustomer) {
    return <Observable<SCData<CourseCustomer>>>(
      this.http.post(`/course-user/me`, data)
    );
  }

  changePassword(password: string) {
    return <Observable<SCData<CourseCustomer>>>(
      this.http.patch(`/course-auth/me/change-password`, { password })
    );
  }

  getCountries() {
    return <Observable<SCData<Country[]>>>(
      this.http.get(`/course-user/countries`)
    );
  }
}
